export default {"src":"/_next/static/media/nature-landscape.colour.9d678a69.svg","height":333,"width":364,"blurWidth":0,"blurHeight":0};